import { StakingStorage } from './interface'
import Big from 'big.js'
import { productMetadataAtom } from '../../index-details/storage/index'
import { ePHTR } from '../../../products'
import { stakingProductRequestFactory } from '../../../services/query-v2/products/staking/product-info/index'
import { atom, useAtomValue, useSetAtom } from 'jotai'
import { AnyWritableAtom } from 'components/scope-provider'
import { userStakingBalanceAtomFactory } from '../../../services/query-v2/products/staking/user/index'
import { Address } from 'viem'
import { loadable } from 'jotai/utils'

const productRequestAtom = stakingProductRequestFactory()
const loadableProductRequestAtom = loadable(productRequestAtom.response)

const userStakingBalance = userStakingBalanceAtomFactory()
const loadableUserStakingBalance = loadable(userStakingBalance.response)

export const productDataAtom = atom(async (get) => {
  const loadableAtom = await get(loadableProductRequestAtom)
  if (loadableAtom.state === 'hasData') {
    return loadableAtom.data
  }
  return {
    totalStaked: Big(0),
    ytdReturns: Big(0),
  }
})

export const stakingBalanceAtom = atom((get) => {
  const loadableAtom = get(loadableUserStakingBalance)
  if (loadableAtom.state === 'hasData') {
    return loadableAtom.data
  }
  return Big(0)
})

export const getStakingStorage = (): StakingStorage => {
  const productData = useAtomValue(productDataAtom)
  const userStaked = useAtomValue(stakingBalanceAtom) ?? Big(0)
  return { ...productData, userStaked }
}

export const createStakingStorageAtoms = (userAddress: Address): [AnyWritableAtom, unknown][] => {
  const { address } = ePHTR
  const setUserAddress = useSetAtom(userStakingBalance.userAddress)
  setUserAddress(userAddress)

  const setProductAddress = useSetAtom(userStakingBalance.productAddress)
  setProductAddress(address)

  return [
    [productRequestAtom.productAddress, address],
    [userStakingBalance.productAddress, address],
    [userStakingBalance.userAddress, userAddress],
    [productMetadataAtom, ePHTR],
  ]
}
